import { ChipProps } from "@mui/material";

import { AppointmentAttendanceStatus } from "@/pages/clients/client/components/tabs/notes-tab/CaseNotes.types";

export const AppointmentStatusSymbol: Record<AppointmentAttendanceStatus, string> = {
  [AppointmentAttendanceStatus.Attended]: "ok",
  [AppointmentAttendanceStatus.CancelledOrRescheduled]: "x",
  [AppointmentAttendanceStatus.NoShow]: "?",
  [AppointmentAttendanceStatus.RescheduledByStaff]: "---",
};

export const AppointmentStatusColor: Record<AppointmentAttendanceStatus, ChipProps["color"]> = {
  [AppointmentAttendanceStatus.Attended]: "success",
  [AppointmentAttendanceStatus.CancelledOrRescheduled]: "error",
  [AppointmentAttendanceStatus.NoShow]: "warning",
  [AppointmentAttendanceStatus.RescheduledByStaff]: "default",
};
